// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Library
import moment from "moment";
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import instance from "../../../../store/axios";
import { LOADING } from "../../../../store/actions";
import clsx from "clsx";
import { useParams } from "react-router-dom";

const AccessAccount: React.FC<any> = (): any => {
  const { customerId } = useParams();
  const dispatch = useDispatch();
  const [accessAccountData, setAccessAccountData] = useState<any>();

  useEffect(() => {
    getAccessAccountData();
  }, []);

  const getAccessAccountData = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/user/${customerId}`
      );
      setAccessAccountData(response.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/home/customer-profile/${customerId}`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  return accessAccountData ? (
    <div className="flex gap-5 flex-wrap mb-5">
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">ID</p>
        <span className=" text-base font-semibold text-lightGray-200">
          {accessAccountData?.id || "-"}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Account status
        </p>
        <span
          className={clsx(
            " text-base font-semibold w-[80px] flex items-center justify-center h-[35px] rounded-md",
            accessAccountData?.status === "verified"
              ? "bg-red-200 text-white"
              : accessAccountData?.status === "pending"
                ? "bg-yellow-500 text-white"
                : "bg-gray-600 text-green-500"
          )}
        >
          {accessAccountData?.status || "-"}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Full name
        </p>
        <span className=" text-base font-semibold text-lightGray-200">
          {accessAccountData?.firstName} {accessAccountData?.lastName}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">Email</p>
        <span className=" text-base font-semibold text-lightGray-200">
          {accessAccountData?.email || "-"}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Mobile number
        </p>
        <span className=" text-base font-semibold text-lightGray-200">
          {accessAccountData?.phoneNumber || "-"}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Last access
        </p>
        <span className=" text-base font-semibold text-lightGray-200">
          {accessAccountData.tokens?.length &&
            accessAccountData.tokens[0]?.createdAt
            ? moment(accessAccountData.tokens[0]?.createdAt).format(
              "DD MMM, YYYY hh:mm A"
            )
            : "-"}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Created at
        </p>
        <span className=" text-base font-semibold text-lightGray-200">
          {moment(accessAccountData?.createdAt).format("MMM DD, YYYY hh:mm A")}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Updated at
        </p>
        <span className=" text-base font-semibold text-lightGray-200">
          {moment(accessAccountData?.updatedAt).format("MMM DD, YYYY hh:mm A")}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Email status
        </p>
        <span
          className={clsx(
            " text-base font-semibold w-[100px] flex items-center justify-center h-[35px] rounded-md",
            !accessAccountData?.emailVerified
              ? "bg-yellow-500 text-white"
              : "bg-gray-600 text-green-500"
          )}
        >
          {accessAccountData?.emailVerified ? "Verified" : "Pending"}
        </span>
      </div>
      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
        <p className=" text-black-300 text-xs font-normal mb-[10px]">
          Mobile status
        </p>
        <span
          className={clsx(
            " text-base font-semibold w-[80px] flex items-center justify-center h-[35px] rounded-md",
            !accessAccountData?.phoneVerified
              ? "bg-yellow-500 text-white"
              : "bg-gray-600 text-green-500"
          )}
        >
          {accessAccountData?.phoneVerified ? "Verified" : "Pending"}
        </span>
      </div>
    </div>
  ) : (
    ""
  );
};

export default AccessAccount;
